const trackPage = () => {
  window.analytics?.page({
    path: window.location.pathname,
    referrer: document.referrer,
    search: window.location.search,
    title: document.title,
    url: window.location.href,
  });
};

document.addEventListener('analytics:ready', trackPage, { once: true });
